/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LiveBiddingLogDto } from '../models/live-bidding-log-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedLiveBiddingLogService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getLiveBiddingLog
   */
  static readonly GetLiveBiddingLogPath = '/api/live-bidding-log/{lotId}';

  /**
   * Gets the live-bidding-log for a specified lot.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLiveBiddingLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingLog$Response(params: {
    lotId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LiveBiddingLogDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedLiveBiddingLogService.GetLiveBiddingLogPath, 'get');
    if (params) {
      rb.path('lotId', params.lotId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LiveBiddingLogDto>;
      })
    );
  }

  /**
   * Gets the live-bidding-log for a specified lot.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLiveBiddingLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveBiddingLog(params: {
    lotId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<LiveBiddingLogDto> {

    return this.getLiveBiddingLog$Response(params,context).pipe(
      map((r: StrictHttpResponse<LiveBiddingLogDto>) => r.body as LiveBiddingLogDto)
    );
  }

}
